import { getLanguageTexts } from '@sharedInterfaces/Language/languageHelper';
import CardBox from '@src/App/Components/Cards/CardBox/CardBox';
import type { AppState } from '@store/store';
import React from 'react';
import { useSelector } from 'react-redux';

import ThemeEditor, { type ThemeEditorProps } from './ThemeEditor';

export default function ThemeEditorCard(props: ThemeEditorProps): JSX.Element {
    const lang = useSelector((state: AppState) => state.employee.language);
    const langStrings = getLanguageTexts(lang).settings;

    return (
        <CardBox title={langStrings.coloringTitle}>
            <ThemeEditor {...props} fullWidth={true} size="large" />
        </CardBox>
    );
}
